import OfferEvent from '@core/models/offer/OfferEvent';
import {
    Ref,
    ref,
} from '@vue/composition-api';

import { BetBuilderOddsSelection } from '../types/BetBuilderOddsSelection';

interface MEBBOddsRepositoryService {
    repository: Ref<Record<OfferEvent['id'], BetBuilderOddsSelection>>;
}

let mebbOddsRepositoryService: MEBBOddsRepositoryService | null = null;

export const useMEBBOddsRepository = () => {
    if (!mebbOddsRepositoryService) {
        mebbOddsRepositoryService = createBetBuilderOddsSelectionService();
    }

    return mebbOddsRepositoryService;
};

/**
 * This singleton could/should contain all logic from useMEBBOddsSelection singleton as well
 * but it is used to keep useMEBBSummaryOddsSelections lean as it is used in UserSelectionsContainer.
 *
 * UserSelectionsContainer is part of the static bundle and needs to be lean.
 */
const createBetBuilderOddsSelectionService = (): MEBBOddsRepositoryService => {
    const repository = ref<Record<OfferEvent['id'], BetBuilderOddsSelection>>({});

    return {
        repository,
    };
};
